<template>
  <div>
    <div
      class="serverTitle"
    >
      <h4 style="margin-bottom:15px">
        {{ serverData.id }}
      </h4>
      <div style="display:flex; justify-content: space-between;">
        <img src="@/assets/images/serverIcon.png">
        <div style="display:flex; justify-content: space-between;">
          <div style="text-align:center; font-size: 10px">
            <radial-progress-bar
              :diameter="50"
              :completed-steps="parseFloat(serverData.total_CPU)"
              :total-steps="100"
              :stroke-width="6"
              :inner-stroke-width="6"
              inner-stroke-color="#02838024"
              start-color="#028380"
              stop-color="#028380"
            />CPU<br>{{ serverData.total_CPU }}%</div>
          <div class="separator" />
          <div style="text-align:center; font-size: 10px">
            <radial-progress-bar
              :diameter="50"
              :completed-steps="parseFloat(serverData.memory_percen)"
              :total-steps="100"
              :stroke-width="6"
              :inner-stroke-width="6"
              inner-stroke-color="#02838024"
              start-color="#028380"
              stop-color="#028380"
            />RAM<br>{{ serverData.memory_percen }}%</div>
          <div class="separator" />
          <div style="text-align:center; font-size: 10px">
            <radial-progress-bar
              :diameter="50"
              :completed-steps="parseFloat(serverData.used_disk_GB)"
              :total-steps="parseFloat(serverData.total_disk_GB)"
              :stroke-width="6"
              :inner-stroke-width="6"
              inner-stroke-color="#02838024"
              start-color="#028380"
              stop-color="#028380"
            />DISK <span style="font-size:8px">(FREE)</span><br> {{ serverData.free_disk_GB }} GB </div>
        </div></div>
      <div style="text-align:center; font-size: 10px; margin-top: 20px">
        RUNNING TIME: {{ serverData.running_time_seconds }}
      </div>
    </div>
  </div>
</template>
<script>
import RadialProgressBar from 'vue-radial-progress'

export default {
  components: {
    RadialProgressBar,
  },
  props: {
    data: {
      required: true,
      type: [String, Object, Array],
    },
  },
  computed: {
    serverData() {
      const { data } = this
      const serverdata = JSON.parse(data.data)
      return {
        id: data.id,
        timestamp: data.timestamp,
        total_CPU: serverdata.total_CPU,
        memory_percen: serverdata.memory_percen,
        available_RAM_GB: (Math.round(serverdata.available_RAM_GB * 100) / 100),
        used_RAM_GB: (Math.round(serverdata.used_RAM_GB * 100) / 100),
        used_disk_GB: (Math.round(serverdata.used_disk_GB * 100) / 100),
        free_disk_GB: (Math.round(serverdata.free_disk_GB * 100) / 100),
        total_disk_GB: (Math.round(serverdata.total_disk_GB * 100) / 100),
        running_time_seconds: this.timeFormat(Math.round(serverdata.running_time_seconds)),
      }
    },
  },
  methods: {
    timeFormat(t) {
      const h = Math.floor(t / 3600)
      const m = Math.floor((t % 3600) / 60)
      const s = Math.floor(t % 60)

      const hDisplay = h > 0 ? (h < 10 ? '0' : '') + h : '00'
      const mDisplay = m > 0 ? (m < 10 ? '0' : '') + m : '00'
      const sDisplay = s > 0 ? (s < 10 ? '0' : '') + s : '00'
      return `${hDisplay}:${mDisplay}:${sDisplay}`
    },
  },
}
</script>
<style>
.serverTitle{
  margin-bottom: 10px;
}
.separator{
  margin: 0 10px;
  border-right: 1px solid #ccc;
}
</style>
